import React from 'react'
import ReactDOM from 'react-dom'
import App from './app/App'
import registerServiceWorker from './services/registerServiceWorker'

ReactDOM.render(<App/>, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js